import { render, staticRenderFns } from "./AddOrUpdateAccompanyMeal.vue?vue&type=template&id=a5c67ff4&scoped=true&"
import script from "./AddOrUpdateAccompanyMeal.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateAccompanyMeal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c67ff4",
  null
  
)

export default component.exports